import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showMenu: !(window.innerWidth > 1270),
  expandState: 'show'
  //   isFullscreen: false
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    toggleMenu: (state) => {
      state.showMenu = !state.showMenu;
    },
    updateExpandState: (state, action) => {
      state.expandState = action.payload;
    }
    // setFullscreen: (state, action) => {
    //   state.isFullscreen = action.payload;
    // }
  }
});

export const { toggleMenu, setFullscreen, updateExpandState } = menuSlice.actions;

export default menuSlice.reducer;
